import React from 'react';
import {useTranslation} from '../../../context/language';
import WebModal from '../../atoms/WebModal';

const PrivacyModal: React.FC<{content: string, visible: boolean, setVisible: any}> = ({content, visible, setVisible}) => {
  const {title} = useTranslation();
  function createMarkup() {
    return {__html: content};
  }
  const handleClose = () => {
    setVisible(false)
  };
  return (
    <WebModal
      visible={visible}
      title={title.privacyPolicy}
      handleClose={handleClose}>
        <div dangerouslySetInnerHTML={createMarkup()} />
    </WebModal>
  );
};

export default PrivacyModal;
